// {
// 	suiteId:"",//套餐Id
// 	suiteName:"",//套餐名称
// 	describe:"",//描述
// 	unitPrice:0,//单价
// 	quantity:0,//数量
// }

export function getCart() {
 var cart= localStorage.getItem("cart");
 if(cart)return JSON.parse(cart)
 else return [];
}

export function setCart(cart) {
   localStorage.setItem("cart",JSON.stringify(cart))
}

export function addCart(item) {
	var cart= getCart();
	var suite=cart.find(function(p){return p.suiteId===item.suiteId})
	if(suite!=null){
		suite.quantity++;
	}
	else cart.push(item);
	setCart(cart);
}


export function getToken() {
 var TonkenStr= sessionStorage.getItem("CloudPeisToken");
 return JSON.parse(TonkenStr)
}

export function setToken(token) {
   sessionStorage.setItem("CloudPeisToken",JSON.stringify(token))
}

export function removeToken() {
  sessionStorage.removeItem("CloudPeisToken")
}


export function getExclusiveId() {
	var result=sessionStorage.getItem("CloudPeisExclusiveId");
 return result;
}

export function setExclusiveId(val) {
   sessionStorage.setItem("CloudPeisExclusiveId",val)
}